export type MetricViewActiveTab =
  | 'product-flow'
  | 'dora'
  | 'code-quality'
  | 'devex-survey'
  // PRODOPSAI-385: drill-down tab values inserted between Product Flow and
  // DORA. Three discrete values let the URL bookmark the open drill-down.
  | 'hygiene-drill-unlinked'
  | 'hygiene-drill-statuses'
  | 'hygiene-drill-types';

interface ITabCopy {
  title: string;
  subtitle: string;
}

const TAB_COPY: Record<MetricViewActiveTab, ITabCopy> = {
  'product-flow': {
    title: 'Product Flow',
    subtitle:
      'How work moves through your team. The four Product Flow metrics together tell you whether delivery is healthy, predictable, and improving.',
  },
  dora: {
    title: 'Engineering (DORA)',
    subtitle:
      'How fast and safely you ship. The four DORA metrics tell you where the team sits on the industry elite → low tiering, and where engineering risk is concentrated.',
  },
  'code-quality': {
    title: 'Code Quality',
    subtitle:
      'Coming soon — coverage, quality gate %, new bugs/vulnerabilities and dependency risks per stream, sourced from SonarCloud.',
  },
  'devex-survey': {
    title: 'DevEx Survey',
    subtitle: 'Quarterly developer experience survey results across teams.',
  },
  'hygiene-drill-unlinked': {
    title: 'Unlinked items',
    subtitle: 'In-scope items with no parent Epic. Most recent first.',
  },
  'hygiene-drill-statuses': {
    title: 'Non-spine statuses',
    subtitle: 'Statuses observed in scope that are not in the canonical spine.',
  },
  'hygiene-drill-types': {
    title: 'Non-canonical types',
    subtitle: 'In-scope items whose issue type is not in the canonical set.',
  },
};

interface MetricViewHeaderProps {
  activeTab: MetricViewActiveTab;
}

export function MetricViewHeader({ activeTab }: Readonly<MetricViewHeaderProps>) {
  const copy = TAB_COPY[activeTab];

  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight text-foreground">{copy.title}</h1>
      <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{copy.subtitle}</p>
    </div>
  );
}
